import ContactInformation from "./Contact";
import GeneralInformation from "./General";
import LocationInformation from "./Location";
import TemplateFileInformation from "./TemplateFile";

export {
  ContactInformation,
  GeneralInformation,
  LocationInformation,
  TemplateFileInformation
}